(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-cro-assurance"] && !Shopify.designMode) return;
  try {
    class ProductCroAssurance extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.section = this.closest('.shopify-section') || document;
      this.stock = this.querySelector('[data-cro-stock]');
      this.sticky = this.querySelector('[data-cro-sticky]');
      this.stickyButton = this.querySelector('[data-cro-sticky-submit]');
      this.variantTitle = this.querySelector('[data-cro-variant-title]');
      this.price = this.querySelector('[data-cro-price]');
      this.variants = this.parseVariants();
      this.handleSelection = () => {
        cancelAnimationFrame(this.syncFrame);
        this.syncFrame = requestAnimationFrame(() => requestAnimationFrame(() => this.syncVariant()));
      };
      this.handleVariantUpdate = (event) => {
        const variantId = event.detail?.variant?.id || event.detail?.resource?.id || event.detail?.id;
        this.syncVariant(variantId);
      };
      this.section.addEventListener('change', this.handleSelection, true);
      this.section.addEventListener('input', this.handleSelection, true);
      document.addEventListener('variant:update', this.handleVariantUpdate);
      this.refreshNativeControls();
      this.setupStickyButton();
      this.setupCountdown();
      this.syncVariant();
    }

    disconnectedCallback() {
      this.section?.removeEventListener('change', this.handleSelection, true);
      this.section?.removeEventListener('input', this.handleSelection, true);
      document.removeEventListener('variant:update', this.handleVariantUpdate);
      cancelAnimationFrame(this.syncFrame);
      this.formObserver?.disconnect();
      this.buttonObserver?.disconnect();
      if (this.countdownInterval) clearInterval(this.countdownInterval);
    }

    parseVariants() {
      try {
        return JSON.parse(this.querySelector('[data-cro-variants]')?.textContent || '[]');
      } catch {
        return [];
      }
    }

    refreshNativeControls() {
      const nextButton = this.section.querySelector('form[action*="/cart/add"] button[name="add"]');
      const nextInput = this.section.querySelector('form[action*="/cart/add"] input[name="id"]');
      this.nativeButton = nextButton;
      this.variantInput = nextInput;

      if (this.observedInput !== nextInput) {
        this.formObserver?.disconnect();
        this.observedInput = nextInput;
        if (nextInput) {
          this.formObserver = new MutationObserver(this.handleSelection);
          this.formObserver.observe(nextInput, { attributes: true, attributeFilter: ['value'] });
        }
      }

      if (this.observedButton !== nextButton) {
        this.buttonObserver?.disconnect();
        this.observedButton = nextButton;
        if (nextButton) {
          this.buttonObserver = new IntersectionObserver(([entry]) => {
            if (this.sticky) this.sticky.dataset.visible = entry.isIntersecting ? 'false' : 'true';
          }, { threshold: 0.15 });
          this.buttonObserver.observe(nextButton);
        } else if (this.sticky) {
          this.sticky.dataset.visible = 'false';
        }
      }
    }

    setupStickyButton() {
      if (!this.stickyButton) return;
      if (document.getElementById('PBarNextFrame') && this.sticky) this.sticky.dataset.previewBar = 'true';
      this.stickyButton.addEventListener('click', () => {
        this.refreshNativeControls();
        if (this.nativeButton && !this.nativeButton.disabled) this.nativeButton.click();
      });
    }

    currentVariant(forcedId) {
      const inputId = this.variantInput?.value;
      const urlId = new URL(window.location.href).searchParams.get('variant');
      const variantId = forcedId || inputId || urlId || this.dataset.initialVariant;
      return this.variants.find((variant) => String(variant.id) === String(variantId));
    }

    syncVariant(forcedId) {
      this.refreshNativeControls();
      const variant = this.currentVariant(forcedId);
      if (!variant) return;
      const threshold = Number(this.dataset.stockThreshold || 5);
      const isLow = Boolean(
        variant.inventory_management &&
        variant.inventory_policy === 'deny' &&
        variant.available &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= threshold
      );

      if (this.stock) {
        this.stock.hidden = !isLow;
        this.stock.textContent = isLow
          ? this.dataset.lowStockTemplate.replace('__COUNT__', String(variant.inventory_quantity))
          : '';
      }

      if (this.variantTitle) this.variantTitle.textContent = variant.title;
      if (this.price) {
        const planId = this.nativeButton?.closest('form')?.querySelector('input[name="selling_plan"]')?.value;
        const allocation = variant.selling_plans?.find((plan) => String(plan.id) === String(planId));
        this.price.textContent = allocation
          ? `${allocation.formatted_price} ${this.dataset.perDelivery}`
          : variant.formatted_price;
      }

      if (this.stickyButton) {
        this.stickyButton.disabled = !variant.available;
        const label = this.stickyButton.querySelector('[data-cro-sticky-label]');
        if (label) label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }
    }

    setupCountdown() {
      const countdown = this.querySelector('[data-cro-countdown]');
      const time = countdown?.querySelector('time');
      if (!countdown || !time) return;
      const end = Date.parse(time.dateTime);
      if (!Number.isFinite(end) || end <= Date.now()) return;
      countdown.hidden = false;

      const update = () => {
        const remaining = end - Date.now();
        if (remaining <= 0) {
          countdown.hidden = true;
          clearInterval(this.countdownInterval);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        countdown.querySelector('[data-cro-days]').textContent = String(days).padStart(2, '0');
        countdown.querySelector('[data-cro-hours]').textContent = String(hours).padStart(2, '0');
        countdown.querySelector('[data-cro-minutes]').textContent = String(minutes).padStart(2, '0');
        countdown.querySelector('[data-cro-seconds]').textContent = String(seconds).padStart(2, '0');
        const accessibleLabel = countdown.querySelector('[data-cro-countdown-label]');
        if (accessibleLabel) {
          accessibleLabel.textContent = this.dataset.countdownLabelTemplate
            .replace('__DAYS__', String(days))
            .replace('__HOURS__', String(hours))
            .replace('__MINUTES__', String(minutes))
            .replace('__SECONDS__', String(seconds));
        }
      };

      update();
      this.countdownInterval = setInterval(update, 1000);
    }
  }

  if (!customElements.get('product-cro-assurance')) {
    customElements.define('product-cro-assurance', ProductCroAssurance);
  }
  } catch(e) { console.error(e); }
})();

})();
